import { render, staticRenderFns } from "./NewPatientMen.vue?vue&type=template&id=2a7664fe&scoped=true&"
import script from "./NewPatientMen.vue?vue&type=script&lang=js&"
export * from "./NewPatientMen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a7664fe",
  null
  
)

export default component.exports